import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-turbine-legend',
    templateUrl: './turbine-legend.component.html',
    styleUrls: ['./turbine-legend.component.scss'],
    standalone: false
})
export class TurbineLegendComponent implements OnInit {

  public colours: any[];

  constructor() {
    this.colours = [
      {
        code: 1,
        explanation: 'COLORSCODE.EXPLANATION_1',
        example: 'COLORSCODE.EXAMPLE_1'
      },
      {
        code: 2,
        explanation: 'COLORSCODE.EXPLANATION_2',
        example: 'COLORSCODE.EXAMPLE_2'
      },
      {
        code: 3,
        explanation: 'COLORSCODE.EXPLANATION_3',
        example: 'COLORSCODE.EXAMPLE_3'
      },
      {
        code: 4,
        explanation: 'COLORSCODE.EXPLANATION_4',
        example: 'COLORSCODE.EXAMPLE_4'
      },
      {
        code: 5,
        explanation: 'COLORSCODE.EXPLANATION_5',
        example: 'COLORSCODE.EXAMPLE_5'
      },
      {
        code: 6,
        explanation: 'COLORSCODE.EXPLANATION_6',
        example: 'COLORSCODE.EXAMPLE_6'
      },
      {
        code: 7,
        explanation: 'COLORSCODE.EXPLANATION_7',
        example: 'COLORSCODE.EXAMPLE_7'
      },
      {
        code: 8,
        explanation: 'COLORSCODE.EXPLANATION_8',
        example: 'COLORSCODE.EXAMPLE_8'
      },
    ];
  }

  ngOnInit() { }

}
